import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { take } from 'rxjs';
import { TruncatePipe } from '../../basic/pipes/truncate.pipe';
import { Methodology } from '../../core/methodology/methodology';
import { MethodologyService } from '../../core/methodology/methodology.service';
import { UpgradeToPremiumComponent } from '../../domain/membership/upgrade-to-premium/upgrade-to-premium.component';
import { NewEditMethodologyComponent } from '../../domain/methodology/new-edit-methodology/new-edit-methodology.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';

@Component({
  selector: 'app-methodology',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzPopconfirmModule,

    TruncatePipe,

    MatTooltip,

    UpgradeToPremiumComponent,
    BasicPageComponent,
    NewEditMethodologyComponent,
  ],
  templateUrl: './methodology.component.html',
  styleUrl: './methodology.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MethodologyComponent {
  selectedItem = signal<Methodology | undefined>(undefined);

  isNewEditVisible = false;

  isEdit = false;

  methodologyList = toSignal(this.methodologyService.methodologyList$(), { initialValue: [] });

  constructor(private methodologyService: MethodologyService) {}

  onEditClick(data: Methodology) {
    this.isEdit = true;
    this.selectedItem.set(data);
    this.isNewEditVisible = true;
  }

  onNewBtnClick() {
    this.isEdit = false;
    this.isNewEditVisible = true;
  }

  onDeleteClick(i: number) {
    this.methodologyService.deleteMethodologyList$([this.methodologyList()[i]]).pipe(take(1)).subscribe();
  }
}
